import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    videos:[],
    resourcevideos:[],
};

const wellnessVideosSlice = createSlice({
    name: 'wellnessvideos',
    initialState,
    reducers: {
        fetchVideos: (state, action) => {
            state.videos = action.payload
          },
          fetchResourceVideos: (state, action) => {
            state.resourcevideos = action.payload
          },
    },
})

export const {fetchVideos, fetchResourceVideos} = wellnessVideosSlice.actions

export default wellnessVideosSlice.reducer;